/**
 * IMF global page script — tiny, runs on every template.
 *
 * Hero marquee first-visit fade: the stylesheet fades the marquee over ~5s
 * while <body> lacks .imf-hero-seen. This flag logic originally lived in the
 * imf-byod extension script, which exits immediately on any page without an
 * artwork block — so it never ran on the homepage, where the marquee actually
 * is. It lives here now, loaded from theme.liquid on every page.
 */
(function () {
  'use strict'
  try {
    if (typeof sessionStorage === 'undefined' || !document.body) return
    if (sessionStorage.getItem('imfHeroSeen') === '1') {
      document.body.classList.add('imf-hero-seen')
    } else {
      // flag only after the animation has had time to play, so a fast second
      // navigation cannot cut the first impression short
      setTimeout(function () {
        try { sessionStorage.setItem('imfHeroSeen', '1') } catch (e) { /* private mode */ }
      }, 5200)
    }
  } catch (e) { /* blocked storage: fade repeats, which is harmless */ }
})()
